/**
 * An object storing the configuration for categories in the menu drawer
 * @module drawerCategories
 * @summary Drawer categories configuration
 */
import DashboardIcon from '@material-ui/icons/Dashboard'
import ActionsIcon from '@material-ui/icons/Block'
import GeoIcon from '@material-ui/icons/Directions'
import IntegrationsIcon from '@material-ui/icons/SettingsInputSvideo'
import ManagementIcon from '@material-ui/icons/AccountBox'
import ReportIcon from '@material-ui/icons/MultilineChart'

export default {
  HOME: {
    name: 'Home',
    key: 'HOME',
    icon: DashboardIcon,
    order: 1
  },
  ACTIONS: {
    name: 'Actions & Events',
    key: 'ACTIONS',
    icon: ActionsIcon,
    order: 2
  },
  GEO: {
    name: 'Geo Services',
    key: 'GEO',
    icon: GeoIcon,
    order: 3
  },
  REPORT: {
    name: 'Report',
    key: 'REPORT',
    icon: ReportIcon,
    order: 4
  },
  INTEGRATIONS: {
    name: 'Integrations',
    key: 'INTEGRATIONS',
    icon: IntegrationsIcon,
    order: 5
  },
  MANAGEMENT: {
    name: 'Management',
    key: 'MANAGEMENT',
    icon: ManagementIcon,
    order: 6
  }
}
